<template>
  <div class="landing-page">
    <b-container fluid class="landing-page" style="background-color: black;">
      <b-modal v-model="showModal" content-class="bg-dark text-light" @ok="onApproveVideo">
        <template #modal-title>
          <span class="text-light">Camera Access</span>
        </template>
        <div class="text-light">
          Please turn on your camera
        </div>
        <template #modal-footer>
          <b-button variant="outline-light" @click="showModal = false">
            Cancel
          </b-button>
          <b-button variant="light" @click="requestCameraAccess">
            OK
          </b-button>
        </template>
      </b-modal>

      <div class="parent">
        <video autoplay playsinline />
      </div>
      <div v-show="!cameraAccessGranted">
        <img src="images/default-image.jpg" alt="Default Image">
      </div>
      <div class="animated-logo-with-reflection" />
    </b-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      cameraAccessGranted: false,
      stream: null,
      showModal: true,
      srcObject: null
    }
  },
  mounted () {
  },
  methods: {
    onApproveVideo () {
      this.cameraAccessGranted = true

      this.requestCameraAccess()
    },

    requestCameraAccess () {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

      const constraints = {
        audio: true,
        video: {
          width: 1280,
          height: 720,
          facingMode: isMobile ? 'user' : 'environment'
        }
      }

      const video = document.querySelector('video')

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((mediaStream) => {
          video.srcObject = mediaStream
          this.showModal = false
          video.onloadedmetadata = () => {
            video.play()
          }
        })
        .catch((err) => {
          // always check for errors at the end.
          console.error(`${err.name}: ${err.message}`)
        })
    }
  }
}
</script>

<style scoped>
.landing-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: white;
}
video {
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}
img {
  width: 100%;
  height: auto;
}
.parent {
  position: relative;
  height: 100vh;
  overflow: hidden;
}
.animated-logo-with-reflection {
  position: absolute;
  margin-top: 0px;
  width: 400px;
  height: 300px;
  background-image: url('/images/DropsLogoSmal-ccl.gif');
  background-position: -75px;
  background-size: cover;
  opacity: 0.5;
}
</style>
